<style scoped lang="scss" type="text/scss">
    .file-download-panel-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 5rem;
        box-sizing: border-box;
        height: 2rem;
        font-size: .75rem;
        background-color: #417DFF;
        color: #FFF;
        transition: all .2s;
        border-bottom-left-radius: .15rem;

        .icon {
            margin-right: .25rem;
        }

        &:hover {
            cursor: pointer;
            transform: scale(1.1);
        }
    }
</style>

<style lang="scss" type="text/scss">
    .download-panel.check-boxes {
        width: 11rem;

        .vertical-check-item {
            margin-top: .25rem;
            width: 100%;

            &:first-of-type {
                margin-top: 0;
            }
        }
    }
</style>

<template>
    <el-popover
            placement="bottom"
            trigger="click">
        <div class="download-panel check-boxes">
            <el-checkbox v-for="item in items" size="small" :key="item.key" v-model="option[item.key]"
                         class="vertical-check-item"
                         :label="item.title" border>
            </el-checkbox>
            <el-button type="primary" plain style="width: 100%; margin-top: .25rem" size="mini"
                       @click="download" :loading="requesting" :disabled="allFalse"
            >
                确认导出
            </el-button>
        </div>

        <div class="file-download-panel-container" slot="reference">
            <i class="icon">&#xe6b0;</i>
            <span>文件导出</span>
        </div>
    </el-popover>
</template>

<script>
    export default {
        name: '',
        data () {
            return {
                requesting: false,
                option: {
                    player: true,
                    player_information: true,
                    contact: true,
                    certificate_overview: true,
                    certificate_detail: true,
                    referee: true,
                    narrator: true,
                    flag_bearer: true,
                    introduce: true,
                    funding: true,
                    sponsorship: true,
                    robot: true,
                    consignee: true,
                    present: true,
                    accommodation: true,
                    student_information: true,
                    teacher_information: true,
                    propagandists_information: true,
                    taobao_information: true,
                    forecast_attendance_information: true,
                    forecast_attendance_group: true,
                    forecast_attendance_people: true,
                },
                items: [
                    {
                        title: '参赛队中期结果.xls',
                        key: 'player'
                    },
                    {
                        title: '参赛队基本信息.xls',
                        key: 'player_information'
                    },
                    {
                        title: '联系人.xls',
                        key: 'contact'
                    },
                    {
                        title: '证书名单-概览.xls',
                        key: 'certificate_overview'
                    },
                    {
                        title: '证书名单-明细.xls',
                        key: 'certificate_detail'
                    },
                    {
                        title: '推荐裁判.xls',
                        key: 'referee'
                    },
                    {
                        title: '推荐解说.xls',
                        key: 'narrator'
                    },
                    {
                        title: '推荐旗手.xls',
                        key: 'flag_bearer'
                    },
                    {
                        title: '解说基础信息.doc',
                        key: 'introduce'
                    },
                    {
                        title: '总经费.xls',
                        key: 'funding'
                    },
                    {
                        title: '赞助.xls',
                        key: 'sponsorship'
                    },
                    {
                        title: '机器人.xls',
                        key: 'robot'
                    },
                    {
                        title: '收件信息.xls',
                        key: 'consignee'
                    },
                    {
                        title: '到场情况.xls',
                        key: 'present'
                    },
                    {
                        title: '住宿信息.xls',
                        key: 'accommodation'
                    },
                    {
                        title: '学生个人信息.xls',
                        key: 'student_information'
                    },
                    {
                        title: '教师个人信息.xls',
                        key: 'teacher_information'
                    },
                    {
                        title: '宣传员信息.xls',
                        key: 'propagandists_information'
                    },
                    {
                        title: '淘宝信息.xls',
                        key: 'taobao_information'
                    },
                    {
                        title: '各赛项预报名信息.xls',
                        key: 'forecast_attendance_information'
                    },
                    {
                        title: '预报名汇总.xls',
                        key: 'forecast_attendance_group'
                    },
                    {
                        title: '预报名人员.xls',
                        key: 'forecast_attendance_people'
                    },
                ]
            };
        },
        computed: {
            currentCompetitionId () {
                return this.$store.state.competition.currentCompetitionId;
            },
            allFalse () {
                const option = this.option;
                let allFalse = true;
                for (const key in option) {
                    if (option[key] === true) allFalse = false;
                }
                return allFalse;
            }
        },
        methods: {
            download () {
                this.$normalRequest('player/downloadRegistrationDataZip', {
                    ...this.option,
                    competition_id: this.currentCompetitionId
                }, false, false, this, 'requesting').then(data => {
                    this.$download(data);
                }).catch(_ => {
                });
            }
        }
    };
</script>
